import {
  PieChartOutlined,
  FileMarkdownOutlined,
  FormOutlined,
  UsergroupAddOutlined,
  PrinterOutlined,
  EditOutlined,
  DiffOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  LineChartOutlined,
  RiseOutlined,
  UploadOutlined,
  DownloadOutlined,
  SnippetsOutlined,
  RetweetOutlined,
  TableOutlined,
  AppstoreAddOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import * as Columns from "./Columns";
import * as Forms from "./Forms";
import {
  PaymentType,
  SalePerm,
  MainWindow,
  Admin,
  Manager,
  Cashier,
} from "../utils/enums";
import { SaleDashboard, Count, CountingEdit } from "../components";

/* Үндсэн мэню болон саб меню нүүд мөн түүнд хамаарах цонхны тохиргоо, хүснэгтын багандууд, формууд бүгдийн энд бүртгэнэ */
export const MAIN_MENU = (props) => [
  {
    name: "Борлуулалт",
    route: "/sale",
    img: "borluulalt",
    title: "Борлуулалт үүсгэх, тооцоо хийх ",
    permission: SalePerm,
    type: MainWindow.Zaal,
    permission: [Admin, Cashier],
  },
  {
    name: "Бүртгэл",
    route: "/management/menu",
    img: "burtgel",
    title: "Бараа болон ангилал бүртгэх",
    type: MainWindow.Menu,
    permission: [Admin, Manager],
    menus: [
      {
        name: "Ангилал бүртэл",
        icon: <PrinterOutlined />,
        id: 1,
        isNew: true,
        isList: true,
        isDoubleClick: true,
        isEdit: true,
        columns: Columns.CategoryColumns,
        method: "POST",
        forms: Forms.CategoryAdd,
        url: "/product/category/list",
        model: "categorylist",
        permission: [Admin, Manager],
      },
      {
        name: "Бараа бүртгэл",
        icon: <FormOutlined />,
        url: "/product/list",
        model: "productlist",
        method: "POST",
        id: 2,
        isNew: true,
        isList: true,
        isDoubleClick: true,
        isEdit: true,
        columns: Columns.ProductListColumns,
        forms: Forms.ProductAddForms,
        initialValues: { note: "" },
        controls: "barcode",
        permission: [Admin, Manager],
      },
      {
        name: "Нийлүүлэгч бүртгэл",
        icon: <EditOutlined />,
        url: "/product/supplier/list",
        model: "supplierlist",
        method: "POST",
        id: 3,
        isNew: true,
        isList: true,
        isDoubleClick: true,
        isEdit: true,
        columns: Columns.SupplierListColumn,
        forms: Forms.SupplierAdd,
        initialValues: { note: "" },
        controls: "barcode",
        permission: [Admin, Manager],
      },
      {
        name: "Дэлгүүрийн бараа бүртгэл",
        icon: <DiffOutlined />,
        url: "/user/storelist",
        model: "store",
        method: "GET",
        id: 4,
        isList: true,
        isDoubleClick: true,
        isEdit: true,
        columns: Columns.StoreListColumns,
        forms: Forms.StoreProductForm,
        permission: [Admin],
      },
    ],
  },
  {
    name: "Тайлан",
    route: "/management/report",
    img: "tailan",
    title: "Тайлангууд харах",
    type: MainWindow.Tailan,
    menus: [
      {
        name: "Хяналт",
        icon: <PieChartOutlined />,
        isList: true,
        component: SaleDashboard,
        id: 1,
        permission: [Admin],
      },
      {
        name: "Борлуулалтын тайлан",
        icon: <LineChartOutlined />,
        isList: true,
        id: 2,
        method: "POST",
        url: "/report/sale",
        model: "salereport",
        isPagination: true,
        controls: "sdate,edate,storeid",
        columns: Columns.SaleReportColumns,
        permission: [Admin, Manager, Cashier],
      },
      {
        name: "Барааны борлуулалтын тайлан",
        icon: <BarChartOutlined />,
        isList: true,
        id: 3,
        method: "POST",
        url: "/report/product",
        model: "productreport",
        isPagination: true,
        controls: "sdate,edate,storeid",
        columns: Columns.SaleDetReportColumns,
        permission: [Admin, Manager, Cashier],
      },
      {
        name: "Татан авалтын тайлан",
        icon: <AreaChartOutlined />,
        isList: true,
        id: 4,
        method: "POST",
        url: "/report/buy",
        model: "buyreport",
        isPagination: true,
        controls: "sdate,edate",
        columns: Columns.BuyReportColumns,
        permission: [Admin, Manager],
      },
      {
        name: "Нөөцын тайлан",
        icon: <RiseOutlined />,
        isList: true,
        id: 5,
        method: "POST",
        url: "/report/inventory",
        model: "inventoryreport",
        isPagination: true,
        controls: "edate,storeid,defstoreid",
        columns: Columns.InvReportColumns,
        isEdit: true,
        forms: Forms.InvForm,
        editpermission: [Admin, Manager],
        permission: [Admin, Manager],
      },
      {
        name: "Хөдөлгөөн /илгээсэн/",
        icon: <UploadOutlined />,
        isTab: true,
        isList: true,
        id: 6,
        method: "POST",
        url: "/report/move/true",
        model: "goproduct",
        isPagination: true,
        controls: "sdate,edate,storeid",
        columns: Columns.MoveReportColumns,
        permission: [Admin, Manager, Cashier],
      },
      {
        name: "Хөдөлгөөн /ирсэн/",
        icon: <DownloadOutlined />,
        isTab: true,
        isList: true,
        id: 7,
        method: "POST",
        url: "/report/move/false",
        model: "comeproduct",
        isPagination: true,
        controls: "sdate,edate,storeid",
        columns: Columns.MoveReportColumns,
        permission: [Admin, Manager, Cashier],
      },
      {
        name: "Баримтын жагсаалт",
        icon: <PrinterOutlined />,
        id: 8,
        isList: true,
        columns: Columns.SaleListColumns,
        url: "/sale/salelist",
        model: "repsalelist",
        isPagination: true,
        method: "POST",
        controls: "sdate,edate,saletype,storeid",
        permission: [Admin, Manager, Cashier],
      },
      {
        name: "Кассчны тооцоо",
        icon: <FileMarkdownOutlined />,
        id: 9,
        method: "POST",
        url: "/sale/set/list",
        model: "cashierList",
        isList: true,
        isPagination: true,
        permission: [Admin, Manager, Cashier],
        columns: Columns.CashierReportColumns,
        controls: "sdate,edate,storeid",
      },
    ],
  },
  {
    name: "Орлого",
    route: "/management/buying",
    img: "orlogo",
    title: "Орлого",
    type: MainWindow.Menu,
    menus: [
      {
        id: 1,
        name: "Бараа татан авах",
        icon: <DownloadOutlined />,
        url: "/product/buy/list",
        model: "buyproductlist",
        method: "POST",
        isNew: true,
        isList: true,
        isDoubleClick: true,
        isEdit: true,
        columns: Columns.BuyListColumns,
        forms: Forms.BuyingAddForms,
        initialValues: { note: "" },
        controls: "sdate,edate,barcode,supplier",
        permission: [Admin, Manager],
      },
      {
        id: 2,
        name: "Захиалга",
        icon: <SnippetsOutlined />,
        url: "/order/list",
        model: "orderlist",
        method: "POST",
        isNew: true,
        isList: true,
        isDoubleClick: true,
        isEdit: true,
        columns: Columns.OrderListColumns,
        forms: Forms.OrderAddForms,
        initialValues: { text: "" },
        controls: "sdate,edate",
        permission: [Admin, Manager, Cashier],
      },
      {
        id: 3,
        name: "Хөдөлгөөн",
        icon: <RetweetOutlined />,
        url: "/movement/list",
        model: "movementlist",
        method: "POST",
        isNew: true,
        isList: true,
        isDoubleClick: true,
        isEdit: true,
        columns: Columns.MoveListColumns,
        forms: Forms.MoveAddForms,
        initialValues: { text: "" },
        controls: "sdate,edate,storeid,fromid",
        checkCashier: true,
        permission: [Admin, Manager, Cashier],
      },
    ],
  },
  {
    name: "Тооллого",
    route: "/management/counting",
    img: "toollogo",
    title: "Тооллого",
    type: MainWindow.Menu,
    menus: [
      {
        id: 1,
        name: "Тооллогын жагсаалт",
        icon: <TableOutlined />,
        url: "/count/list",
        model: "countlist",
        method: "POST",
        isList: true,
        columns: Columns.CountListColumns,
        forms: Forms.BuyingAddForms,
        initialValues: { note: "" },
        controls: "sdate,edate",
        permission: [Admin, Manager, Cashier],
      },
      {
        id: 2,
        name: "Тооллого хийх",
        icon: <AppstoreAddOutlined />,
        isList: true,
        component: Count,
        permission: [Admin, Manager],
      },
      {
        name: "Тооллого засалт",
        icon: <SettingOutlined />,
        isList: true,
        component: CountingEdit,
        id: 3,
        permission: [Admin],
      },
    ],
  },
  {
    name: "Тохиргоо",
    route: "/management/settings",
    img: "tohirgoo",
    title: "Системийн тохиргоонууд",
    type: MainWindow.Tohirgoo,
    permission: [Admin],
    menus: [
      {
        name: "Хэрэглэгчийн эрх",
        isSettings: true,
        icon: <UsergroupAddOutlined />,
        id: 1,
        menus: [
          {
            name: "Хэрэглэгчийн бүртгэл",
            id: 1,
            isList: true,
            isNew: true,
            isEdit: true,
            changePassBtn: true,
            columns: Columns.UserPermColumns,
            forms: Forms.UserPermForms,
            method: "POST",
            url: "/user/list",
            model: "userlist",
            permission: [Admin],
          },
        ],
      },
    ],
  },
];

export const PaymentTypes = [
  {
    name: "Бэлнээр",
    type: PaymentType.Бэлнээр,
    isActive: true,
    cname: "Бэлэн",
    isPayed: true,
  },
  {
    name: "Картаар",
    type: PaymentType.Картаар,
    isActive: true,
    cname: "Карт",
    isPayed: true,
  },
  {
    name: "Мобайлаар",
    type: PaymentType.Мобайлаар,
    isActive: true,
    cname: "Мобайл",
    isPayed: true,
  },
    {
    name: "Зээл",
    type: PaymentType.Зээл,
    isActive: true,
    cname: "Зээл",
    isPayed: true,
  },
];

export const BillTypeData = [
  { label: "Хувь хүн", value: 1 },
  { label: "Байгууллага", value: 3 },
];
